const formatText = (text: string) => {
  return text
    .replace(/_+/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

export default formatText;
